<template>
  <div class="device-detail-slot-list">
    <div
      class="slot-item"
      v-for="(item,index) in listData"
      :key="index"
      :class="{conflict: item.conflict, empty: !item.hasRoute}"
      @click="onClick(item)"
    >
      <div class="slot-item-header">
        <div class="char">{{item.char}}</div>
        <div
          class="line"
          v-if="item.tips"
        ></div>
        <div class="title">{{item.tips}}</div>
        <i
          @click="onEditRouteName(item)"
          class="icon icon-bianji1"
          v-if="item.hasRoute && !item.conflict && edit"
        ></i>
        <i
          @click="onDel(item)"
          class="icon icon-shanchu"
          v-if="item.hasRoute && !item.conflict && del"
        ></i>
      </div>
      <img
        :src="item.productIcon"
        alt=""
        class="slot-img"
        v-if="item.productIcon"
      >
      <div
        class="slot-item-footer"
        v-if="item.hasRoute"
      >
        {{$momentLocal(item.gmtCreate)}}
      </div>
    </div>
    <conflict-route-dialog
      v-if="conflictSlotVisible"
      @close="conflictSlotVisible=false"
      :model="conflictSlotModel"
      :del="del"
    ></conflict-route-dialog>
    <edit-route-name-dialog
      v-if="editRouteNameVisible"
      @close="editRouteNameVisible = false"
      :model="editRouteNameModel"
      @success="getTableList"
    ></edit-route-name-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import editRouteNameDialog from './edit_route_name_dialog.vue';
import conflictRouteDialog from './device_detail_conflict_route_dialog.vue';

export default {
  name: 'deviceDetailSlotList',
  mixins: [],
  components: {
    conflictRouteDialog,
    editRouteNameDialog
  },
  props: {
    data: Object,
    // 是否有编辑权限
    edit: Boolean,
    // 是否有删除权限
    del: Boolean,
  },
  data() {
    return {
      list: [],
      listData: [],
      conflictSlotVisible: false,
      conflictSlotModel: {},
      editRouteNameVisible: false,
      editRouteNameModel: {},
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onEditRouteName(data) {
      const row = data.data[0];
      this.editRouteNameModel = {
        data: row
      };

      this.editRouteNameVisible = true;
    },
    onDelCallback() {
      this.getTableList();
      this.$emit('del');
    },
    async onDel(data) {
      const row = data.data[0];
      const { slotCode, mapName } = row;
      // const slotCodeName = this.dicMap.sbr_slot[slotCode];
      // 所选路线的槽号+路线名称
      const subStr = [slotCode, mapName].filter(val => !!val).join('/');
      await this.$showConfirm(this, subStr ? this.$t('device_detail_slot_list.qdyscolxm', [subStr]) : '');
      const reqUrl = `${apis.hlcSlotDelete}/${row.hlcSlotId}`;
      await this.$postJSON(reqUrl);
      this.$message({
        message: this.$t('Common.com_delete_success'),
        type: 'success'
      });
      this.onDelCallback();
    },
    onClick(item) {
      if (item.conflict) {
        const char = item.char;
        const row = item.data[0];
        const {
          hlcCode, locationName, siteName
        } = row;
        const title = [hlcCode, locationName, siteName, char].join('/');

        this.conflictSlotModel = {
          title,
          data: row
        };
        this.conflictSlotVisible = true;
      }
    },
    formatList(list) {
      const charArr = 'A B C D E F';
      const listData = charArr.split(' ').map(char => ({
        char,
        data: [],
      }));

      // 将list按slotCode进行分组
      list.forEach((item) => {
        const curSlotCode = item.slotCode;
        const pNode = listData.find(obj => obj.char === curSlotCode);
        if (pNode) {
          pNode.data.push(item);
        }
      });

      listData.forEach((item) => {
        // 格式化是否有路线，是否冲突
        if (!item.data.length) {
          item.hasRoute = false;
        } else {
          item.hasRoute = true;
          if (item.data.length > 1) {
            item.conflict = true;
          }
        }

        // 格式化gmtCreate
        if (item.data.length) {
          item.gmtCreate = item.data[item.data.length - 1].gmtCreate;
        }

        const arr = [];
        // 格式化小标题
        if (item.data.length) {
          const info = item.data[item.data.length - 1];
          if (info.mapName) {
            arr.push(`(${info.mapName})`);
          }
        }
        item.tips = arr.join(' ');

        // 获取图片
        if (item.data.length) {
          const info = item.data[item.data.length - 1];
          if (info.mapId) {
            const data = {
              bizId: info.mapId,
              bizType: 'i'
            };
            this.$getFileList(data).then((fileList) => {
              if (fileList && fileList.length) {
                const curIndex = this.listData.findIndex(obj => obj.char === item.char);
                const file = fileList[0];
                if (curIndex >= 0) {
                  const slotItem = this.listData[curIndex];
                  this.$set(slotItem, 'productIcon', file.attachPath || file.url);
                }
              }
            });
          }
        }
      });

      return listData;
    },
    getTableList() {
      const { productCode, siteId, hlcCode } = this.data;
      const reqUrl = `${apis.hlcSlotAppSoltList}/${productCode}/${siteId}/${hlcCode}`;
      this.$getJSON(reqUrl).then((res) => {
        if (!res.data) {
          res.data = [];
        }
        const list = res.data;
        const listData = this.formatList(list);
        this.list = list;
        this.listData = listData;
      });
    },
  },
  created() {
  },
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss">
.device-detail-slot-list {
  overflow: hidden;
  padding: 0 0 16px 16px;
  margin-bottom: 20px;

  .slot-item {
    position: relative;
    width: 184px;
    height: 112px;
    float: left;
    border-radius: 4px;
    margin-top: 16px;
    margin-right: 16px;
    overflow: hidden;
    box-shadow: 0 0 0 1px rgba(179, 179, 179, 0.2) inset;

    &.empty {
      background-color: #f8f8f8;
      .slot-item-header {
        background-color: transparent;
        .char {
          color: #4d4d4d;
        }
      }
    }

    &.conflict {
      cursor: pointer;
      .slot-item-header {
        background: rgba(255, 173, 0, 0.9) !important;
      }
    }

    &-header {
      position: relative;
      z-index: 10;
      height: 28px;
      line-height: 28px;
      overflow: hidden;
      background: rgba(77, 77, 77, 0.9);
      .char {
        float: left;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        padding: 0 8px;
      }
      .line {
        float: left;
        background: rgba(255, 255, 255, 0.9);
        width: 1px;
        height: 12px;
        margin-top: 8px;
        margin-right: 8px;
      }
      .title {
       overflow: hidden;
        color: #fff;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 50%;
        float: left;
      }

       .icon {
        cursor: pointer;
      }

      .icon-bianji1,
      .icon-shanchu {
        float: right;
        font-size: 14px;
        line-height: 28px;
        color: #00a0d9;
      }

      .icon-shanchu {
        margin-right: 10px;
      }

      .icon-bianji1 {
        margin-right: 10px;
      }

      .icon-conflict {
        float: right;
        font-size: 14px;
        line-height: 28px;
        color: #202945;
      }
    }

    &-footer {
      position: absolute;
      z-index: 10;
      left: 1px;
      right: 1px;
      bottom: 1px;
      margin: auto;
      height: 19px;
      line-height: 20px;
      color: #4d4d4d;
      font-size: 12px;
      text-align: center;
      background: rgba(248, 248, 248, 0.9);
    }

    .slot-img {
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      max-width: 95%;
      max-height: 95%;
    }
  }
}
</style>
